import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '@/axios';
import { GET_COUNTRY_RISKS_KEY } from '@/keys';
import type { CountryRisk, CountryRiskLevel } from '@/types/core/country-risk';

export function useUpdateCountryRisk() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, risk }: { id: number; risk: CountryRiskLevel }) =>
      (await api.patch<CountryRisk>(`/country-risks/${id}`, { risk })).data,
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: GET_COUNTRY_RISKS_KEY }),
  });
}
